import { __generator } from "tslib";
import { all, takeLatest, call, put } from 'redux-saga/effects';
import { Url } from '@wix/da-url';
import { isApiError, request } from '../../xhr';
import { setCompliantLocalStorageItem } from '../../redux/compliantLocalStorage/actions';
import { CompliantLocalStorageKeys } from '../../redux/compliantLocalStorage/constants';
import { API_BASE_PATH } from '../constants';
import { setSocialLoginError, attemptSocialLogin, socialLoginSuccess, } from './actions';
function handleLogin(action) {
    var _a, provider, token, redirectToJoin, redirectToSisu, response, errors, errorKey;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = action.payload, provider = _a.provider, token = _a.token, redirectToJoin = _a.redirectToJoin, redirectToSisu = _a.redirectToSisu;
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        baseURL: API_BASE_PATH,
                        url: '/signin_social',
                        data: {
                            provider: provider,
                            provider_token: token,
                        },
                    })];
            case 1:
                response = _d.sent();
                if (!(!response || isApiError(response))) return [3 /*break*/, 3];
                return [4 /*yield*/, put(setSocialLoginError('general'))];
            case 2:
                _d.sent();
                return [2 /*return*/];
            case 3:
                errors = (_b = response.errors) !== null && _b !== void 0 ? _b : [];
                if (!(!response.success || errors.length > 0)) return [3 /*break*/, 5];
                errorKey = errors.length > 0 ? errors[0] : '';
                return [4 /*yield*/, put(setSocialLoginError(errorKey))];
            case 4:
                _d.sent();
                return [2 /*return*/];
            case 5: return [4 /*yield*/, put(setSocialLoginError(undefined))];
            case 6:
                _d.sent();
                if (!redirectToSisu) return [3 /*break*/, 8];
                if (response.loggedin) {
                    window.location.assign(Url.browseHomeLink());
                    return [2 /*return*/];
                }
                return [4 /*yield*/, put(setCompliantLocalStorageItem({
                        key: CompliantLocalStorageKeys.SOCIAL,
                        value: "".concat(provider, ":").concat((_c = response.tokenId) !== null && _c !== void 0 ? _c : ''),
                    }))];
            case 7:
                _d.sent();
                window.location.assign(Url.joinLink());
                return [2 /*return*/];
            case 8: return [4 /*yield*/, put(socialLoginSuccess({
                    provider: provider,
                    response: response,
                    redirectToJoin: redirectToJoin,
                }))];
            case 9:
                _d.sent();
                return [2 /*return*/];
        }
    });
}
export default function socialSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([takeLatest(attemptSocialLogin, handleLogin)])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map